import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/authContext';
import { deleteArticle, getArticlesByUserId, getFilteredArticlesByUserId } from '../api/articleApi';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { deleteUser } from '../api/authApi';
import { useLanguage } from '../context/languageContext';

const UserPage = ({ langValue }) => {
  const navigator = useNavigate();
  const { language } = useLanguage();
  const { user, setUser } = useContext(AuthContext);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeFilter, setActiveFilter] = useState(0);
  const filterValues = ['Все', 'Новости', 'Статьи'];

  // useEffect(() => {
  //   const fetchArticles = async () => {
  //     try {
  //       const token = user?.token;
  //       const articlesData = await getArticlesByUserId(token, currentPage);
  //       setArticles(articlesData.articles);
  //       setTotalPages(articlesData.totalPages);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (user) {
  //     fetchArticles();
  //   }
  // }, [user, currentPage]);

  const fetchArticles = async () => {
    try {
      const token = user?.token;

      if (activeFilter !== 0) {
        const filteredData = await getFilteredArticlesByUserId(
          token,
          currentPage,
          activeFilter - 1,
        );
        setArticles(filteredData.articles);
        setTotalPages(filteredData.totalPages);
      } else {
        const articlesData = await getArticlesByUserId(token, currentPage);
        setArticles(articlesData.articles);
        setTotalPages(articlesData.totalPages);
      }
    } catch (err) {
      setError(err.message);
      setArticles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [activeFilter, currentPage, user]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigator('/auth/login');
  };

  const handleDeleteArticle = async (slug) => {
    if (window.confirm('Вы уверены, что хотите удалить эту статью?')) {
      try {
        const token = user?.token;
        await deleteArticle(slug, token);
        setArticles((prevArticles) => prevArticles.filter((article) => article.slug !== slug));
      } catch (error) {
        alert('Ошибка при удалении статьи. Попробуйте еще раз.');
      }
    }
  };

  const handleDeleteUser = async () => {
    if (window.confirm('Вы уверены, что хотите удалить свой аккаунт? Это действие необратимо.')) {
      try {
        const token = user?.token;
        await deleteUser(token);
        localStorage.removeItem('token');
        setUser(null);
        navigator('/auth/login');
      } catch (error) {
        alert('Ошибка при удалении аккаунта. Попробуйте еще раз.');
      }
    }
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <div className="loading">
        <ClipLoader size={50} color={'#123abc'} loading={true} />
      </div>
    );
  }

  return (
    <div className="userpage">
      <div className="userpage-container">
        <div className="userdata-container">
          <h2>Ваш аккаунт</h2>
          <div className="userdata">
            <div className="userdata-info">
              <p>
                <span>username:</span> {user?.userData?.username}
              </p>
              <p>
                <span>email:</span> {user?.userData?.email}
              </p>
            </div>

            <div className="userdata-btns">
              <button onClick={handleDeleteUser}>Удалить аккаунт</button>
              <button onClick={handleLogout}>Выйти из аккаунт</button>
            </div>
          </div>
        </div>

        <div>
          <h3>Ваши посты</h3>
          <div className="userpage-filter">
            {filterValues.map((item, i) => {
              return (
                <button
                  className={`filter-btn ${i === activeFilter ? 'active-filter-btn' : ''}`}
                  onClick={() => {
                    setActiveFilter(i);
                    setCurrentPage(1);
                    fetchArticles();
                  }}>
                  {item}
                </button>
              );
            })}
          </div>
          <div className="userposts-container">
            {(articles.length === 0 || error) && (
              <p className="userposts-error">У вас пока нет постов</p>
            )}

            {articles.length > 0 &&
              articles.map((article) => (
                <div
                  className="userpost"
                  key={article.id}
                  onClick={() => navigator(`/articles/${article.slug}`)}>
                  {article.image && (
                    <div className="article-image-container">
                      <img src={article.image} alt="article-img" className="article-image" />
                    </div>
                  )}

                  <div className="userpost-text">
                    <p>Тип поста: {article.type}</p>
                    <h4>{language === 'rus' ? article.title : article.titleBel}</h4>
                  </div>

                  <div className="userpost-btns">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator(`/edit/${article.slug}`);
                      }}>
                      Изменить
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteArticle(article.slug);
                      }}>
                      Удалить
                    </button>
                  </div>
                </div>
              ))}
          </div>
          <div className="pagination-block">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              style={{ width: '30px', height: '27px' }}>
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.41 12.16L4.75 6.5L10.41 0.839996L11.11 1.55L6.16 6.5L11.11 11.45L10.41 12.16ZM6.41 12.16L0.75 6.5L6.41 0.839996L7.11 1.55L2.16 6.5L7.11 11.45L6.41 12.16Z"
                  fill="black"
                />
              </svg>
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ width: '26px', height: '27px' }}>
              <svg
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.41 12.16L0.75 6.5L6.41 0.839996L7.11 1.55L2.16 6.5L7.11 11.45L6.41 12.16Z"
                  fill="black"
                />
              </svg>
            </button>
            <span>
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ width: '26px', height: '27px' }}>
              <svg
                width="8"
                height="13"
                viewBox="0 0 8 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.58965 12.16L7.24965 6.5L1.58965 0.839996L0.889648 1.55L5.83965 6.5L0.889648 11.45L1.58965 12.16Z"
                  fill="black"
                />
              </svg>
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              style={{ width: '30px', height: '27px' }}>
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.58965 0.839996L7.24965 6.5L1.58965 12.16L0.889648 11.45L5.83965 6.5L0.889648 1.55L1.58965 0.839996ZM5.58965 0.839996L11.2496 6.5L5.58965 12.16L4.88965 11.45L9.83965 6.5L4.88965 1.55L5.58965 0.839996Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPage;
